module.exports = __webpack_public_path__ + "img/americanexpress.251a59e4.svg";